module.exports = __webpack_public_path__ + "static/media/12.13b3fabc.jpeg";